module.exports = __webpack_public_path__ + "static/media/square-casks.29e10f86.jpg";